import { app } from '../../../../../../app';
import { Controller } from './import-users-to-label.controller';

app.component('companyUserLabelMembersImport', {
    bindings: {
        companyUsers: '=',
		regCompanyUsers: '<',
        companyId: '<',
		userLabelId:'<',
        labels: '<'
    },
    controller: Controller,
    templateUrl: require('./import-users-to-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/import/import-users-to-label.component.js